import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ArrowDownIcon } from 'lucide-react';
import { HeroSpecimen } from './HeroSpecimen';
export function Hero() {
  return <section aria-labelledby="hero-heading" className="w-full bg-navy" data-id="element-109" data-mp="joym22hz564q">
      <div className="mx-auto grid max-w-shell gap-12 px-5 py-14 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)] lg:items-center lg:gap-16 lg:px-10 lg:py-24" data-id="element-110" data-mp="jn5f0m3g8jw7">
        <div data-id="element-111" data-mp="apl6cs39blbk">
          <p className="flex items-center gap-3 font-mono text-[10px] tracking-label text-copper" data-id="element-112" data-mp="aq4skkzxwvve">
            <span aria-hidden="true" className="h-px w-8 bg-copper" data-id="element-113" data-mp="5nvx9hzlhhq4" />
            SHEAR GEOMETRY CUTTING TOOLS
          </p>
          <h1 id="hero-heading" className="mt-6 max-w-[19ch] font-display text-[clamp(2.15rem,5vw,4.1rem)] font-medium leading-[1.03] tracking-[-0.02em] text-white" data-id="element-114" data-mp="sgmx00sq3yg">
            High-rake CNC lathe tooling for aluminum, copper &amp; titanium
          </h1>
          <p className="rp-measure mt-7 text-[16px] leading-[1.7] text-aluminum" data-id="element-115" data-mp="1q37l8u1o1kjg">
            Shear Geometry brings together external holders, APGX inserts,
            starter kits and replacement components developed for demanding CNC
            turning applications. Contact Robertson Precision to confirm current
            availability and application fit.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-116" data-mp="1hxrln4roofpj">
            <Link to="/#product-guidance" data-analytics="product-guidance-cta" data-analytics-location="hero" className="inline-flex min-h-[52px] items-center justify-center gap-2 bg-cta px-7 text-[14.5px] font-semibold text-navy transition-colors duration-150 ease-precise hover:bg-white" data-id="element-117" data-mp="25nvf4jb5qz2t">
              Request Product Guidance
              <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-118" data-mp="2okn3361na2d7" />
            </Link>
            <Link to="/#products" className="inline-flex min-h-[52px] items-center justify-center gap-2 border border-aluminum/40 px-7 text-[14.5px] font-medium text-white transition-colors duration-150 ease-precise hover:border-copper hover:text-cta" data-id="element-119" data-mp="2tcob2frs56xf">
              Explore the Tooling System
              <ArrowDownIcon aria-hidden="true" className="h-4 w-4" data-id="element-120" data-mp="2u5vsl18zuffw" />
            </Link>
          </div>

          <p className="mt-6 font-mono text-[11px] leading-relaxed tracking-[0.05em] text-aluminum/80" data-id="element-121" data-mp="2p8cafq96diio">
            For CNC lathes only. Not intended for manual lathes.
          </p>
        </div>

        <HeroSpecimen data-id="element-122" data-mp="2fhhraur86z1g" />
      </div>
    </section>;
}